import { Testimonial } from "../types";

// Public remarks, not customer reviews. Quotation marks stay on what they said.
// The frame is this site's line.

const disclosureQuotes: Testimonial[] = [
  {
    quote: "There are several, actually nine, flying saucers, flying disks, that are out there of extraterrestrial origin.",
    author: "Bob Lazar",
    date: "1989",
    category: "S-4, south of Area 51",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/lazar-hangar.webp",
  },
  {
    quote: "There were nine total that I saw, each one being different.",
    author: "Bob Lazar",
    date: "1989",
    category: "S-4 hangars, Nevada",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/lazar-hulls.webp",
  },
  {
    quote: "I can tell you, I think it was not from this world.",
    author: "Cmdr. David Fravor",
    date: "2017",
    category: "USS Nimitz, Tic Tac, 2004",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/fravor-tictac.webp",
  },
  {
    quote: "We're going to uncover the cover-up.",
    author: "Rep. Tim Burchett",
    date: "2023",
    category: "House Oversight UAP hearing",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/burchett-hearing.webp",
  },
  {
    quote: "The one thing that we can make clear, whether it's aliens or it's us, is that the deep state does not want us to know about what's happening.",
    author: "Rep. Eric Burlison",
    date: "2023",
    category: "House Oversight, after the UAP hearing",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/burlison-archive.webp",
  },
  {
    quote: "I was informed, in the course of my official duties, of a multi-decade UAP crash retrieval and reverse engineering program to which I was denied access.",
    author: "David Grusch",
    date: "2023",
    category: "UAP Task Force, House testimony",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/grusch-wreckage.webp",
  },
  {
    quote: "We don't know what they are yet, but they are real.",
    author: "Luis Elizondo",
    date: "2021",
    category: "Former head of AATIP",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/elizondo-sensors.webp",
  },
  {
    quote: "Every day for at least a couple years.",
    author: "Lt. Ryan Graves",
    date: "2021",
    category: "Navy, off Virginia Beach",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/graves-atlantic.webp",
  },
  {
    quote: "You can't go supersonic and turn on a dime.",
    author: "Lt. Cmdr. Alex Dietrich",
    date: "2023",
    category: "USS Nimitz, Tic Tac, 2004",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/dietrich-streak.webp",
  },
  {
    quote: "The videos, along with observations by pilots and radar operators, appear to provide evidence of the existence of aircraft far superior to anything possessed by the United States or its allies.",
    author: "Christopher Mellon",
    date: "2018",
    category: "Former Deputy Assistant Secretary of Defense",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/mellon-radar.webp",
  },
  {
    quote: "I'm not embarrassed or ashamed or sorry I got this thing going.",
    author: "Sen. Harry Reid",
    date: "2017",
    category: "Senate Majority Leader, on AATIP",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/reid-corridor.webp",
  },
  {
    quote: "Non-human intelligence has been interacting with humanity.",
    author: "Col. Karl Nell",
    date: "2024",
    category: "SALT conference, New York",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/nell-city.webp",
  },
  {
    quote: "I think that at Wright-Patterson Field, if you could get into certain places, you'd find out what the Air Force and the government knows about UFOs.",
    author: "Sen. Barry Goldwater",
    date: "1994",
    category: "Wright-Patterson Air Force Base",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/goldwater-hangar.webp",
  },
  {
    quote: "I happen to have been privileged enough to be in on the fact that we've been visited on this planet and the UFO phenomenon is real.",
    author: "Dr. Edgar Mitchell",
    date: "2008",
    category: "Apollo 14",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/mitchell-moon.webp",
  },
  {
    quote: "I believe that these extraterrestrial vehicles and their crews are visiting this planet from other planets.",
    author: "Gordon Cooper",
    date: "1978",
    category: "Mercury astronaut, letter to the United Nations",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/cooper-lakebed.webp",
  },
  {
    quote: "Within seconds of that call, my missiles start shutting down.",
    author: "Capt. Robert Salas",
    date: "2010",
    category: "Malmstrom Air Force Base, 1967",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/salas-silo.webp",
  },
  {
    quote: "The contours of an amazingly complex intelligent life beyond the earth can already be discerned.",
    author: "Dr. Jacques Vallée",
    date: "1965",
    category: "Astrophysicist",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/vallee-observatory.webp",
  },
  {
    quote: "These are not your grandma's alloys.",
    author: "Dr. Garry Nolan",
    date: "2019",
    category: "Stanford, on reported UAP materials",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/nolan-lab.webp",
  },
  {
    quote: "I was unconscious or dead, most of those days.",
    author: "Travis Walton",
    date: "2025",
    category: "Logger, Snowflake, Arizona, 1975",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/walton-clearing.webp",
  },
  {
    quote: "The preternatural is still the best category that we have for looking at this.",
    author: "Dr. Diana Walsh Pasulka",
    date: "2024",
    category: "Religious studies, American Cosmic",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/pasulka-chapel.webp",
  },
  {
    quote: "Disclosure is just a personal process.",
    author: "Jesse Michels",
    date: "2026",
    category: "American Alchemy",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/michels-desk.webp",
  },
  {
    quote: "Once I became convinced of their physical reality, the more I studied it and the more time I spent with it, the more convinced I became.",
    author: "Leslie Kean",
    date: "2023",
    category: "Journalist",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/kean-desk.webp",
  },
  {
    quote: "The American public has a right to learn about technologies of unknown origins, non-human intelligence, and unexplainable phenomena.",
    author: "Sen. Chuck Schumer",
    date: "2023",
    category: "UAP Disclosure Act",
    frame: "Last attempt at disclosure.",
    image: "/landing/backgrounds/schumer-senate.webp",
  },
  {
    quote: "An ongoing and systematic breeding experiment must be considered one of the central purposes of UFO abductions.",
    author: "Budd Hopkins",
    date: "1987",
    category: "Abduction researcher, on hybrids",
    frame: "Disclosure blast.",
    image: "/landing/backgrounds/hopkins-clinic.webp",
  },
  {
    quote: "Frankly, there are a lot more sightings than have been made public.",
    author: "John Ratcliffe",
    date: "2021",
    category: "Director of National Intelligence",
    frame: "Final message delivered.",
    image: "/landing/backgrounds/ratcliffe-intel.webp",
  },
];

export default disclosureQuotes;
